import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { generate } from '@ant-design/colors';
import { inputToRGB, rgbToHsv, rgbToHex, rgbToHsl, stringInputToObject } from '@ctrl/tinycolor';
/**
 * 生成色盘
 * @param color
 * @param mode
 * @param bgColor
 */
export function colorSeries(color, mode, bgColor) {
  var options = {
    theme: mode,
    backgroundColor: bgColor
  };
  return generate(color, options);
}
/**
 * 判断是否为暗色颜色
 * @param color
 */
export function isDarkColor(color) {
  return luma(color) < 0.75;
}
/**
 * 获取颜色明暗度
 * @param color
 */
export function luma(color) {
  var _inputToRGB = inputToRGB(color),
    r = _inputToRGB.r,
    g = _inputToRGB.g,
    b = _inputToRGB.b;
  var luma = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 255;
  return luma;
}
/**
 * 转 rgb 色值
 * @param color
 */
export function toRgb(color) {
  return inputToRGB(color);
}
/**
 * 转 hex 色值
 * @param color
 */
export function toHex(color) {
  var rgbColor = inputToRGB(color);
  var r = rgbColor.r,
    g = rgbColor.g,
    b = rgbColor.b;
  return rgbToHex(r, g, b, false);
}
/**
 * 转 hsl 色值
 * @param color
 */
export function toHsl(color) {
  var rgbColor = inputToRGB(color);
  var r = rgbColor.r,
    g = rgbColor.g,
    b = rgbColor.b;
  return _objectSpread(_objectSpread({}, rgbToHsl(r, g, b)), {}, {
    a: rgbColor.a
  });
}
var HSV_MATCHER = /^(hsva?)\(( *\d* *,){1,3} *\d* *\)/;
/**
 * 转 hsv 色值
 * @param color
 * @returns
 */
export function toHsv(color) {
  if (HSV_MATCHER.test(color)) {
    return stringInputToObject(color);
  }
  var rgbColor = inputToRGB(color);
  var r = rgbColor.r,
    g = rgbColor.g,
    b = rgbColor.b;
  return _objectSpread(_objectSpread({}, rgbToHsv(r, g, b)), {}, {
    a: rgbColor.a
  });
}
/**
 * 根据主色生成色盘（自动适应背景色）
 * @param color
 * @param background
 */
export function generateColors(color, background) {
  var options = {};
  if (background) {
    if (isDarkColor(background)) {
      options['theme'] = 'dark';
      options['backgroundColor'] = background;
    }
  }
  return generate(color, options);
}
/**
 * 判断两个色值是否相同
 * @param color1
 * @param color2
 */
export function colorEqual(color1, color2) {
  if (!(color1 && color2)) {
    return false;
  }
  return toHex(color1) === toHex(color2);
}
export default {
  colorSeries: colorSeries,
  isDarkColor: isDarkColor,
  toHsl: toHsl,
  toHex: toHex,
  toRgb: toRgb,
  toHsv: toHsv,
  generateColors: generateColors,
  colorEqual: colorEqual
};